/* ============================================================
   assets/int-fp-select.js                   INTENTION — 2026-09-03
   THE FRAMED PRINT MIRROR CONTROLS. One wiring, every width.

   Frame Size and Paper Colour, drawn as the same closed pill the apparel
   size control uses, driving the theme's real inputs underneath.

   ⚑ WHERE IT CAME FROM. This was the wiring half of step 2 in
   assets/int-fp-mobile.js, lifted out on 2026-09-03. That file returns above
   820px, so the pills existed on the phone and framed print DESKTOP was left
   on the theme's own full-width Frame Size popout. Nils: "both Apparel and
   Framed print desktop should have the same stile for size selector as this
   on mobile." Fourth extraction of this shape in one day, after
   assets/int-zoom.js, assets/int-size-select.js and
   assets/int-reveal-lead.js.

   ⚑ WHAT STAYED IN THE MOBILE FILE. The MOVES — putting the buy row under the
   swatches and the price under it — are the phone's arrangement and belong
   there. This file only wires, and places the row on desktop.

   ⚑ THE REAL CONTROLS ARE NEVER MOVED, ONLY MIRRORED. Shopify's "Variant
   Sellout Precrime" builds its selections from FormData ORDER and matches
   variants by position. Moving the .selector-wrapper nodes made Frame Size,
   Paper, Colour line up against Size, Colour, Paper and every value —
   including the selected one — rendered as sold out. Read the header in
   snippets/int-fp-mobile.liquid before touching any of this.
   ============================================================ */
(function () {
  'use strict';
  if (window.__intFpWire) return;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function wire(buyrow) {
    if (!buyrow || buyrow.getAttribute('data-int-fp-wired')) return;
    buyrow.setAttribute('data-int-fp-wired', '1');

    /* ── the mirrors drive the REAL controls ────────────────────────────
       Two shapes to drive, and the order matters:
         · Frame Size is Pipeline's <popout-select>. Its options are
           anchors carrying data-value, and clicking one is what the theme
           listens for. ⚑ Never set the popout's value directly.
         · Paper Colour is a pair of real radios. Check, then fire BOTH
           change and click — the theme binds one and the region-stock
           script the other.
       ⚑ Scope the lookup to the option's own wrapper. A bare
       input[value="..."] walk hits the currency picker and the frame
       colour radios, which is how an earlier version of the swatch code
       ended up selecting the wrong thing. */
    var wired = false;
    qa('[data-int-fp-select]', buyrow).forEach(function (sel) {
      var name = sel.getAttribute('data-int-fp-select');
      var wrap = q('.selector-wrapper[data-select-label="' + name + '"]');
      if (!wrap) return;
      wired = true;
      sel.addEventListener('change', function () {
        var val = sel.value;
        var opt = wrap.querySelector('[data-popout-option][data-value="' + val.replace(/"/g, '\\"') + '"]');
        if (opt) { opt.click(); return; }
        var radios = wrap.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === val) {
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
            radios[i].dispatchEvent(new Event('click', { bubbles: true }));
            return;
          }
        }
      }, false);
    });

    /* Repaint the faces, and the selects, whenever the variant moves for
       any reason — a swatch click, the browser's back button, the theme.
       ⚑ Read the CHECKED INPUTS, never an event payload. The payload is
       whatever the thing that fired it believed; the inputs are what the
       cart will submit. Same rule the paper word in
       int-pdp-identity-line.liquid follows. */
    function syncFaces() {
      qa('[data-int-fp-select]', buyrow).forEach(function (sel) {
        var name = sel.getAttribute('data-int-fp-select');
        var wrap = q('.selector-wrapper[data-select-label="' + name + '"]');
        if (!wrap) return;
        var cur = null;
        var checked = wrap.querySelector('input[type="radio"]:checked');
        if (checked) cur = checked.value;
        if (!cur) {
          var live = wrap.querySelector('[data-popout-option][aria-current="true"], .select-popout__item--current [data-popout-option]');
          if (live) cur = live.getAttribute('data-value');
        }
        if (!cur) return;
        if (sel.value !== cur) sel.value = cur;
        var face = q('[data-int-fp-val="' + name + '"]', buyrow);
        if (face && face.textContent !== cur) face.textContent = cur;
      });
    }
    document.addEventListener('variant:change', function () { setTimeout(syncFaces, 30); }, false);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name && e.target.name.indexOf('options[') === 0) setTimeout(syncFaces, 30);
    }, true);
    [200, 800, 2000].forEach(function (ms) { setTimeout(syncFaces, ms); });
    syncFaces();

    if (wired) document.body.classList.add('int-fp-wired');
  }

  window.__intFpWire = wire;

  /* ── DESKTOP PLACEMENT ─────────────────────────────────────────────────
     Below 821px assets/int-fp-mobile.js moves the row itself and then calls
     wire(). Above it that file never runs, so the row is placed and wired
     here: at the top of the buy column, directly above the price, with the
     theme's own Frame Size popout and Paper Colour radios hidden by
     assets/int-fp-desktop.css.

     ⚑ Hidden, not removed — see the sellout note above. */
  function mountDesktop() {
    try {
      if (!window.matchMedia || !window.matchMedia('(min-width: 821px)').matches) return;
    } catch (e) { return; }

    var buyrow = q('#int-fp-buyrow');
    if (!buyrow) return;
    var price = q('.product__block__price');

    /* ⚑ ON THE PRICE LINE, NOT ABOVE IT. Nils: "Frame Size selector is too
       wide, and not on the same line as price." Placing the row above the
       price left it spanning the whole 414px column with the price on its
       own line underneath.

       Same shape as apparel (assets/int-size-select.js): the price and its
       tax note are SIBLINGS, so turning .product__block__price into a flex
       row without wrapping them first lays all three out side by side and
       the note ends up to the right of the price. Wrap, then insert. */
    if (price && !price.contains(buyrow)) {
      var stack = price.querySelector('.int-price-stack');
      if (!stack) {
        stack = document.createElement('div');
        stack.className = 'int-price-stack';
        while (price.firstChild) stack.appendChild(price.firstChild);
        price.appendChild(stack);
      }
      price.insertBefore(buyrow, price.firstChild);
    }
    document.body.classList.add('int-fp-buyrow-desktop');
    wire(buyrow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountDesktop);
  } else {
    mountDesktop();
  }
})();
